import { format, startOfWeek, addDays } from 'date-fns';
import './MoodGraph.css';

const MoodGraph = ({ moodHistory, moods }) => {
  // Get current week's dates (Monday to Sunday)
  const startOfCurrentWeek = startOfWeek(new Date(), { weekStartsOn: 1 }); // 1 = Monday
  const dates = Array.from({ length: 7 }, (_, i) => {
    const date = format(addDays(startOfCurrentWeek, i), 'yyyy-MM-dd');
    return date;
  });

  return (
    <div className="mood-graph">
      <h3>This Week</h3>
      <div className="mood-timeline">
        {dates.map((date) => {
          const mood = moodHistory.find(m => m.date === date);
          const isToday = date === format(new Date(), 'yyyy-MM-dd');
          
          return (
            <div key={date} className={`mood-day ${isToday ? 'today' : ''}`}>
              <div className="mood-circle">
                {mood ? mood.emoji : ''}
              </div>
              <div className="mood-date">
                {format(new Date(date), 'EEE')}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MoodGraph; 